@if (data.video?.provider === 'YOUTUBE') {
<planone-youtube-video-embed
  [index]="data.index"
  [path]="data.video?.resource"
  [autoplay]="true"
  [showSuggestions]="false"
  width="100%"
  height="auto"
  class="video-slider-item"></planone-youtube-video-embed>
} @else {
<planone-file-video-embed
  [index]="data.index"
  [path]="data.video?.resource"
  width="100%"
  height="auto"
  class="video-slider-item"></planone-file-video-embed>
}
